import { useMutation, useQueryClient } from '@tanstack/react-query'
import { updatePharmacist } from '@/features/internal/pharmacist/apis/pharmacist'
import { PharmacistFormData } from '@/features/internal/pharmacist/types/pharmacist'
import { queryKeys } from '@/shared/hooks/queries/queryKeys'

export const useUpdatePharmacistMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({
      id,
      data,
    }: {
      id: string
      data: Partial<PharmacistFormData>
    }) => updatePharmacist(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.pharmacy.pharmacists(),
      })
    },
  })
}
